import React from 'react';
import { Card, Grid, Typography, Box, Chip } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import PersonOutlined from '@mui/icons-material/PersonOutlined';
import { discLabel } from '../../../../../../constants/disc';
const DISC_COLORS = {
  D: { bg: '#fce4ec', text: '#c62828' },
  I: { bg: '#fff8e1', text: '#f57f17' },
  S: { bg: '#e8f5e9', text: '#2e7d32' },
  C: { bg: '#e3f2fd', text: '#1565c0' }
};

const useStyles = makeStyles()(() => ({
  card: {
    padding: '12px',
    marginBottom: '12px',
    backgroundColor: '#fff'
  },
  infoBox: {
    backgroundColor: '#f8f9fa',
    borderRadius: '8px',
    padding: '12px'
  },
  infoRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '4px 0'
  },
  label: {
    color: '#666',
    fontSize: '13px'
  },
  value: {
    color: '#333',
    fontWeight: 600,
    fontSize: '13px'
  }
}));

const ClientCard = ({ client, intl, children }) => {
  const { classes } = useStyles();
  if (!client?.factsheetId) return null;

  const fs = client.factsheetId;
  const name = fs.name;
  const personality = fs.personality;
  const tags = fs.tags?.map(tag => tag.text).filter(Boolean) || [];
  const gender = fs.gender;
  const marriageStatus = fs.marriageStatus;
  const child = fs.child;
  const monthlyIncome = fs.monthlyIncome;

  const discStyle = DISC_COLORS[personality] || { bg: '#f5f5f5', text: '#757575' };

  const infoItems = [
    { labelId: 'Gender', value: gender },
    { labelId: 'Marriage Status', value: marriageStatus },
    { labelId: 'No. of Child', value: child != null ? String(child) : null },
    { labelId: 'Monthly Income', value: monthlyIncome != null ? `$${Number(monthlyIncome).toLocaleString()}` : null }
  ].filter(item => item.value);

  return (
    <Card className={classes.card}>
      <Grid container spacing={2}>
        {/* Header: Avatar + Name + DISC Badge */}
        <Grid size={12}>
          <Grid container sx={{ alignItems: 'center', justifyContent: 'space-between' }}>
            <Grid>
              <Grid container spacing={1} sx={{ alignItems: 'center' }}>
                <Grid>
                  <Box
                    style={{
                      width: 40,
                      height: 40,
                      borderRadius: '50%',
                      backgroundColor: '#e8eaf6',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                  >
                    <PersonOutlined style={{ width: 24, height: 24, color: '#3966f8' }} />
                  </Box>
                </Grid>
                <Grid>
                  <Typography style={{ color: '#333', fontSize: '20px' }}>{name}</Typography>
                </Grid>
              </Grid>
            </Grid>
            {personality && (
              <Grid>
                <Chip
                  label={discLabel(personality, intl.locale) || personality}
                  size="small"
                  style={{
                    backgroundColor: discStyle.bg,
                    color: discStyle.text,
                    fontWeight: 600,
                    fontSize: '12px'
                  }}
                />
              </Grid>
            )}
          </Grid>
        </Grid>

        {/* Info Rows */}
        {infoItems.length > 0 && (
          <Grid size={12}>
            <Box className={classes.infoBox}>
              {infoItems.map((item, idx) => (
                <Box key={idx} className={classes.infoRow}>
                  <Typography className={classes.label}>{intl.formatMessage({ id: item.labelId })}</Typography>
                  <Typography className={classes.value}>{item.value}</Typography>
                </Box>
              ))}
            </Box>
          </Grid>
        )}

        {/* Tags */}
        {tags.length > 0 && (
          <Grid size={12} style={{ marginBottom: '12px' }}>
            <Box style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
              {tags.map((tag, idx) => (
                <Chip
                  key={idx}
                  label={tag}
                  size="small"
                  style={{
                    backgroundColor: '#e8eaf6',
                    color: '#3966f8',
                    fontSize: '12px'
                  }}
                />
              ))}
            </Box>
          </Grid>
        )}
        {children && <Grid size={12}>{children}</Grid>}
      </Grid>
    </Card>
  );
};

export default ClientCard;
